import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { API } from "@/lib/api";

/** URL publica corta: abre el PDF o una pagina legible si caduco. */
export default function PublicDownloadPage() {
  const { token } = useParams();
  const [msg, setMsg] = useState({ titulo: "Abriendo el DeCA" + String.fromCharCode(0x2026), cuerpo: "" });

  useEffect(() => {
    if (!token) return;
    const url = `${API}/public/d/${token}`;
    let cancelled = false;
    (async () => {
      try {
        const r = await fetch(url, { headers: { Accept: "application/pdf, application/json" } });
        if (cancelled) return;
        if (r.ok) {
          window.location.replace(url);
          return;
        }
        if (r.status === 410) {
          setMsg({
            titulo: "Enlace de descarga caducado",
            cuerpo: "La descarga p" + String.fromCharCode(0xfa) + "blica de este DeCA ya no est" + String.fromCharCode(0xe1) + " activa. Si necesita el documento para una inspecci" + String.fromCharCode(0xf3) + "n, solic" + String.fromCharCode(0xed) + "teselo a la empresa emisora.",
          });
          return;
        }
        if (r.status === 404) {
          setMsg({ titulo: "Enlace no encontrado", cuerpo: "Este enlace de descarga no existe o no es v" + String.fromCharCode(0xe1) + "lido." });
          return;
        }
        setMsg({ titulo: "No se pudo abrir el DeCA", cuerpo: "Int" + String.fromCharCode(0xe9) + "ntalo de nuevo o pide el documento a la empresa emisora." });
      } catch {
        if (!cancelled) window.location.replace(url);
      }
    })();
    return () => { cancelled = true; };
  }, [token]);

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-6">
      <div className="max-w-md w-full bg-white border border-slate-200 rounded-md p-6">
        <div className="text-[10px] tracking-[0.16em] uppercase text-slate-500">DeCA Web</div>
        <h1 className="text-xl font-semibold text-slate-900 mt-1">{msg.titulo}</h1>
        {msg.cuerpo ? <p className="text-sm text-slate-600 mt-2 leading-relaxed">{msg.cuerpo}</p> : null}
      </div>
    </div>
  );
}
